__turbopack_context__.v({
  "playbutton": "FullVideo-module-scss-module__Vlr65a__playbutton",
  "playbuttoninner": "FullVideo-module-scss-module__Vlr65a__playbuttoninner",
  "videoProgressBar": "FullVideo-module-scss-module__Vlr65a__videoProgressBar",
  "videoWrapper": "FullVideo-module-scss-module__Vlr65a__videoWrapper",
  "wrapper": "FullVideo-module-scss-module__Vlr65a__wrapper",
});
